import React from 'react';
import {
  About,
  Advantages,
  Calculator,
  Conditions,
  Contact,
  Equipment,
  FeedbackApp,
  FeedbackFranchise,
  Footer,
  Franchise,
  FranchisePartners,
  Header,
  Info,
  Partners,
  Service
} from './container';

import './styles/main.scss';
import Questions from './container/Questions/Questions';

export const App = () => (
  <>
    <Header />
    <Partners />
    {/* <Conditions /> */}
    <Franchise />
    <Advantages />
    <FeedbackFranchise />
    <FeedbackApp />
    {/* <Equipment /> */}
    <Calculator />
    <Info />
    <Questions/>
    {/* <Service /> */}
    {/* <FranchisePartners /> */}
    {/* <About /> */}
    <Contact />
    <Footer />
  </>
);

export default App;
